var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddresIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 30,
    viewBox: "0 0 24 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7687 16.0769C14.1478 16.0769 16.0764 14.1483 16.0764 11.7692C16.0764 9.39007 14.1478 7.46143 11.7687 7.46143C9.38958 7.46143 7.46094 9.39007 7.46094 11.7692C7.46094 14.1483 9.38958 16.0769 11.7687 16.0769Z",
    stroke: "#56736C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5388 11.7694C22.5388 21.4618 11.7694 29.0004 11.7694 29.0004C11.7694 29.0004 1 21.4618 1 11.7694C1 8.91316 2.13463 6.17393 4.15428 4.15428C6.17393 2.13463 8.91316 1 11.7694 1C14.6256 1 17.3648 2.13463 19.3845 4.15428C21.4041 6.17393 22.5388 8.91316 22.5388 11.7694Z",
    stroke: "#56736C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddresIcon2);
export default __webpack_public_path__ + "static/media/addres-icon-2.60ca60b633ce431ca3bf287241ad1d51.svg";
export { ForwardRef as ReactComponent };